import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';

import { cloneDeep } from '../../utils/lodash';

import { Button, Tab, Tabs, Paper } from '@mui/material';

import { ResizableStyles, resizableX, resizableY } from '../../common/ResizableFrames';
import Node from '../../common/Node'
import Search from '../../common/Search';
import Macros from '../../common/Macros'
import Accordeon from '../../common/Accordeon';
import TrplsTable from '../../common/TrplsTable/TrplsTable';
import Filters from '../../common/Filters';
import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';
import Switcher from '../../common/Switcher';

import {
  nodesParams,
  boxParamsTable,
  prdcParamsTable,
  trplsParamsTableMatching,
  getTransformedNodesArrayToObj,
} from '../../utils';

const styles = {
  tableContainer: {
    margin: '10px 0',
    overflow: 'auto',
    background: '#ffff',
  },
  textDataToSelect: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  linkBlueNode: {
    fontSize: '12px',
    textDecoration: 'none',
    color: '#347CFF',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  macroBlock: {
    width: 'fit-content',
  },
  sellectedNodesList: {
    listStyle: 'none',
    maxHeight: '25vh',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
  selectedNodesLi: {
    pageBreakInside: 'avoid',
    breakInside: 'avoid',
  },
  ...CommonStyles,
  ...ResizableStyles,
};

class PlayGround extends ComponentWrapper {
  state = {
    data: {},
    trigger: {
      trpls: [],
      ancestor: null,
    },
    paused: false,
    nodesData: {},
    filterLoaded: true,
    tableDataLoaded: false,
    macroNode: null,
    macroCode: '',
    macroResult: {},
    nodesResult: [],
    nodesForRequest: [],
    selectedTableNodes: [],
    nodeMacroResultData: {},
    runningDoFuncRequest: false,
    saveMacroRequestResults: true,
    isOpenedNodesForRequest: false,
    currentMainTabValue: 'selectedNode',
  };

  componentDidMount() {
    document.title="Playground | Milkyweb";

    resizableX();
    resizableY();
  };

  onFilterBtnClick = (cleanedFilters, searchValue, filterAncestor) => {
    this.setState({ runningDoFuncRequest: false, paused: false, nodeMacroResultData: {}, macroResult: {} });
    if (Array.isArray(cleanedFilters) && cleanedFilters.length === 0 && !filterAncestor) {
      this.setState({ data: {}, tableDataLoaded: false });
    } else {
      const { setup } = this.props;
      const { trigger } = this.state;

      const reqData = {
        api_key: setup.id,
        filter: trigger,
      };

      reqData.render = {
        trpl: {
          type: "a",
          params: trplsParamsTableMatching,
        },
        node: {
          type: "a",
          params: nodesParams,
        },
        prdc: {
          type: "a",
          params: prdcParamsTable,
        },
        box: {
          type: "a",
          params: boxParamsTable,
        }
      };

      this.setState({ filterLoaded: false, tableDataLoaded: false, data: {} }, () => {
        this.postWithData({
          url: `/pnkqry3`,
          data: reqData,
          cb: (data) => {
            if (data._status === 'ok') {
              data.nodes = getTransformedNodesArrayToObj(data.nodes, nodesParams);
              this.setState({
                data,
                filterLoaded: true,
                tableDataLoaded: true,
                selectedTableNodes: 0,
                nodesData: {
                  //...this.state.nodesData,
                  ...data.nodes,
                },
                nodesForRequest: data.query,
              });
            } else this.setState({ filterLoaded: true, selectedTableNodes: 0, nodesForRequest: [] });
          },
        });
      });
    }
  };

  setUpdatedTableData = (status, data) => {
    const { currentMainTabValue, selectedTableNodes } = this.state;

    if (status === 'ok') {
      this.setState({
        data,
        filterLoaded: true,
        tableDataLoaded: true,
        selectedTableNodes: 0,
        nodesData: {
          //...this.state.nodesData,
          ...data.nodes,
        },
        nodesForRequest:
          currentMainTabValue === 'triggerQuery' && selectedTableNodes.length
          ? selectedTableNodes
          : currentMainTabValue === 'triggerQuery' && data.query
            ? data.query
            : [],
      });
    } else this.setState({ filterLoaded: true, selectedTableNodes: 0, nodesForRequest: [] });
  };

  setGraphTriggerAncestorToParentState = (graphTriggerAncestor) => {
    const triggerCopy = cloneDeep(this.state.trigger);
    if (graphTriggerAncestor) {
      triggerCopy.ancestor = graphTriggerAncestor.id;
      
      this.setState({ trigger: triggerCopy });
    } else {
      const emptyTrigger = {
        trpls: [],
        ancestor: null,
      };
      this.setState({
        tableDataLoaded: false,
        trigger: emptyTrigger,
        data: {},
      });
    }
  };

  setFiltersToState = (filters) => {
    this.setState({
      trigger: {
        ...this.state.trigger,
        trpls: filters,
      }
    });
  };

  addNodeToNodesData = (node) => {
    this.setState({ nodesData: { ...this.state.nodesData, [node.id]: node } })
  };

  onRunBtnClick = () => {
    const { currentMainTabValue, data, macroNode, selectedTableNodes } = this.state;

    this.setState({
      macroResult: {},
      nodesResult: [],
      nodeMacroResultData: {},
      // nodesForRequest:
      //   currentMainTabValue === 'triggerQuery' && data.query && selectedTableNodes.length
      //   ? selectedTableNodes
      //     : currentMainTabValue === 'triggerQuery' && data.query
      //     ? data.query
      //       : currentMainTabValue === 'selectedNode' && macroNode && macroNode.id
      //       ? [macroNode.id]
      //         : [],
    }, () => this.doFunc(0));
  };

  onResumeBtnClick = () => {
    const { macroResult, nodesResult, saveMacroRequestResults } = this.state;

    const nodesObjectResultArray = saveMacroRequestResults ? Object.keys(macroResult) : nodesResult;
    const lastNodeInLoadedIndex = nodesObjectResultArray.indexOf(nodesObjectResultArray[nodesObjectResultArray.length - 1]);

    this.doFunc(lastNodeInLoadedIndex);
  };

  doFunc = (index) => {
    const { nodesForRequest, nodesResult, macroCode, runningDoFuncRequest, paused, nodeMacroResultData, saveMacroRequestResults } = this.state;

    if (!runningDoFuncRequest && !paused) return this.setState({ macroResult: {} });
    if (!runningDoFuncRequest) return;

    const requestData = {
      func: macroCode,
    };

    if (Array.isArray(nodesForRequest) && nodesForRequest.length) requestData.entity_id = nodesForRequest[index];

    this.postWithData({
      disableNotify: true,
      url: `/rest/do_func`,
      data: requestData,
      cb: (data) => {
        if (data._status === 'error') {
          this.setState({
            paused: false,
            runningDoFuncRequest: false,
          }, () => {
            this.notify('error', data._mes, 3);
          });
        } else if (nodesForRequest.length) {
          if (saveMacroRequestResults) {
            this.setState({
              macroResult: { ...this.state.macroResult, [requestData.entity_id]: data.val },
            });
          } else {
            this.setState({
              nodesResult: [...nodesResult, requestData.entity_id],
            });
          }

          if (nodesForRequest[nodesForRequest.length - 1] === nodesForRequest[index]) {
            if (saveMacroRequestResults && !nodesForRequest.includes(+Object.keys(nodeMacroResultData)[0])) this.setNodeMacroResultData(requestData.entity_id);

            this.setState({
              paused: false,
              runningDoFuncRequest: false,
            }, () => {
              this.notify('success', 'Done', 3);
            });
          } else {
            this.doFunc(index + 1);
          }
        } else if (!nodesForRequest.length && data.val) {
          this.setState({
            paused: false,
            runningDoFuncRequest: false,
            macroResult: { 'macro': saveMacroRequestResults ? data.val : '' },
          }, () => {
            this.notify('success', 'Done', 3);
          });
        }
      },
    });
  };

  setNodeMacroResultData = (nodeId) => {
    const { macroResult } = this.state;

    if (!Object.keys(macroResult) || !macroResult[nodeId]) return;
    const nodeMacroResultData = { [nodeId]: macroResult[nodeId] };

    this.setState({ nodeMacroResultData });
  };

  onChangeNodeClick = (node) => {
    if (node && node.id) {
      this.setState({
        macroNode: node, 
        nodesForRequest: node.id ? [node.id] : [],
      });
    } else {
      this.setState({
        macroNode: null,
        nodesForRequest: [],
      });
    }
  };

  getSelecteRowsNodes = (selecteTableRows) => {
    const { data } = this.state;
    this.setState({
      selectedTableNodes: selecteTableRows,
      nodesForRequest: selecteTableRows && selecteTableRows.length ? selecteTableRows : data.query ? data.query : [],
    });
  };

  render() {
    const { classes, light_meta_and_ops } = this.props;
    const {
      data,
      paused,
      trigger,
      macroCode,
      macroNode,
      nodesData,
      nodesResult,
      macroResult,
      filterLoaded,
      nodesForRequest,
      tableDataLoaded,
      selectedTableNodes,
      nodeMacroResultData,
      currentMainTabValue,
      runningDoFuncRequest,
      isOpenedNodesForRequest,
      saveMacroRequestResults,
    } = this.state;

    const selectedMacroResultKey = Object.keys(nodeMacroResultData) && Object.keys(nodeMacroResultData)[0];
    const selectedMacroResultValue = Object.values(nodeMacroResultData) && Object.values(nodeMacroResultData)[0];

    const resultsMacroNodeKeys = saveMacroRequestResults ? macroResult && Object.keys(macroResult) : nodesResult || [];

    return (
      <div style={{ width: '100vw', height: 'calc(100vh - 40px)' }}>
        <div className={`${classes.resizableX}`} style={{ height: '100%' }}>

          <div className={`${classes.mt10} ${classes.flex} ${classes.resizableY}`} style={{ flex: '50%', overflow: 'hidden' }}>
            <div style={{ width: '100%', flex: '70%', overflow: 'hidden' }}>
              <div className={`${classes.ml20} ${classes.mr10}`}>
                <h4 className={`${classes.mr10} ${classes.mb10} ${classes.mt10}`} style={{ color: '#3B3545' }}>Macro</h4>

                <div className={`${classes.mb10} ${classes.mr10}`} style={{ background: '#fff' }}>
                  <Accordeon
                    isOpened={isOpenedNodesForRequest}
                    toggleAccordeon={() => this.setState({ isOpenedNodesForRequest: !isOpenedNodesForRequest })}
                    title={'Nodes for request '}
                    titleRightCol={`${resultsMacroNodeKeys && resultsMacroNodeKeys.length ? resultsMacroNodeKeys.length + ' /' : ' '}
                      ${nodesForRequest.length ? nodesForRequest.length : ' '}`}
                  >
                    <ul className={`${classes.p5} ${classes.sellectedNodesList}`} style={{ color: '#C4C4C4' }}>
                      {nodesForRequest.map((nodeId, index) => {
                        return (
                          <li
                            key={index}
                            className={`
                              ${resultsMacroNodeKeys.length && (resultsMacroNodeKeys.includes(`${nodeId}`)
                                || resultsMacroNodeKeys.includes(nodeId)) ? classes.linkBlueNode : ''}
                              ${classes.selectedNodesLi}
                              `}
                            style={{ fontSize: 12, marginRight: '8px', fontWeight: +selectedMacroResultKey === nodeId ? 'bold' : 500 }}
                            onClick={() => { if (saveMacroRequestResults) this.setNodeMacroResultData(nodeId) }}
                          >
                            {nodeId}
                          </li>
                        )
                      })}
                    </ul>
                  </Accordeon>
                </div>
              </div>

              <div className={`${classes.alignCenter} ${classes.ml30} ${classes.mb10}`}>
                <div className={`${classes.alignCenter} ${classes.mr30}`}>
                  <Switcher
                    switched={saveMacroRequestResults}
                    onChange={() => this.setState({ saveMacroRequestResults: !saveMacroRequestResults})}
                  />
                  <strong style={{ color: '#4C4C4C' }} className={classes.ml5}> {`${"Save results"}`}</strong>
                </div>
                <div className={`${classes.ml10} ${classes.alignCenter}`}>
                  <Button
                    size="small"
                    onClick={() => {
                      if (runningDoFuncRequest) {
                        this.setState({ runningDoFuncRequest: false, paused: true });
                        if (saveMacroRequestResults && resultsMacroNodeKeys.length) this.setNodeMacroResultData(Object.keys(macroResult)[Object.keys(macroResult).length - 1])
                      } else if (paused) {
                        this.setState({ runningDoFuncRequest: true, paused: false }, () => this.onResumeBtnClick());
                      } else {
                        this.setState({ runningDoFuncRequest: true, paused: false, nodeMacroResultData: {}, macroResult: {}, nodesResult: [] }, () => this.onRunBtnClick());
                      }
                    }}
                    className={`${classes.btnBigNormal}`}
                  >
                    {paused ? 'Resume' : runningDoFuncRequest ? 'Pause' : 'Run'}
                  </Button>
                  
                  {runningDoFuncRequest || paused ?
                    <React.Fragment>
                      <Button
                        size="small"
                        onClick={() => {
                          this.setState({ runningDoFuncRequest: false, paused: false, nodeMacroResultData: {}, macroResult: {}, nodesResult: [] },
                            () => this.forceUpdate());
                        }}
                        className={`${classes.btnBigNormal} ${classes.ml20} ${classes.mr20}`}
                      >
                        {'Abort'}
                      </Button>
                    { <span style={{ color: '#C4C4C4' }}>{`${paused ? 'paused' : 'running...'}`}</span>}
                  </React.Fragment>
                  : null}
                </div>
              </div>
  
              <div className={classes.flexRow} style={{ height: '100%', width: 'calc(100%)' }}>
                <Macros
                  editable={true}
                  showCode={true}
                  fullWidth={true}
                  nonResizable={true}
                  functionVal={macroCode}
                  setFunctionPerfValues={(type, val) => {
                    this.setState({ macroCode: val });
                  }}
                />
              </div>
            </div>

            <div className={`resizerY ${classes.resizerY}`}></div>

            <div className={classes.p10} style={{ flex: '5%', overflow: 'auto' }}>
              {(selectedMacroResultValue && nodesForRequest.length && nodesForRequest.includes(+selectedMacroResultKey))
              || selectedMacroResultKey === 'macro' ?
                <div style={{ overflow: 'auto' }}>
                  <pre style={{ fontFamily: "Monospace", color: '#4c4c4c', whiteSpace: 'pre-line' }}>{selectedMacroResultValue}</pre>
                </div>
              : <span className={classes.alignJustifyCenter} style={{ color: '#c4c4c4', overflow: 'hidden' }}>macro run result</span>}
            </div>
          </div>

          <div className={`resizerX ${classes.resizerX}`}></div>
        
          <div className={`${classes.m10}`} style={{ flex: '30%', overflowX: 'auto', overflowY: 'auto', whiteSpace: 'nowrap', minWidth: '200px' }}>
          {/* pointerEvents: (runningDoFuncRequest)? 'none' : '' */}
            <div className={`${classes.inlineFlex} ${classes.ml10} ${classes.mt10} ${classes.mb10}`}>
              <h4 className={`${classes.mr10}`} style={{ color: '#3B3545', whiteSpace: 'nowrap' }}>Run macro on:</h4>
              <div className={classes.alignCenter}>
                <Tabs
                  className={classes.smallTabs}
                  value={currentMainTabValue}
                  onChange={(e, value) => {
                    this.setState({
                      currentMainTabValue: value,
                      nodesForRequest:
                        value === 'triggerQuery' && selectedTableNodes.length
                        ? selectedTableNodes
                          : value === 'triggerQuery' && data.query
                          ? data.query
                            : value === 'selectedNode' && macroNode && macroNode.id
                            ? [macroNode.id]
                              : [],
                    });
                  }}
                >
                  <Tab
                    value={'selectedNode'}
                    label='Selected node'
                  />
                  <Tab
                    value={'triggerQuery'}
                    label='Graph Trigger'
                  />
                </Tabs>
              </div>
            </div>
  
            {currentMainTabValue === 'triggerQuery' ?
              <div style={{ flex: '30%' }}>
                <div className={`${classes.ml10}`} style={{ width: 'fit-content' }}>
                  <Filters
                    defaultBg={true}
                    ancestor={trigger.ancestor}
                    filterBtnText="Apply"
                    loaded={filterLoaded}
                    callbacks={{
                      setGraphTriggerAncestorToParentState: this.setGraphTriggerAncestorToParentState,
                      setFiltersToParentState: this.setFiltersToState,
                      onFiltersSearchNodeCb: this.addNodeToNodesData,
                      onFilterBtnClick: this.onFilterBtnClick,
                    }}
                    graphTriggerAncestor={(light_meta_and_ops.setup_rbox_light && light_meta_and_ops.setup_rbox_light[trigger.ancestor]) || null}
                    initialFilters={trigger.trpls}
                    nodes={nodesData}
                    mode={'edit'}
                    useChain
                  />
                </div>

                {tableDataLoaded ?
                  <div className={`${classes.tableContainer}`}>
                    <TrplsTable
                      //isEmbed
                      callbacks={{
                        getSelecteRowsNodes: this.getSelecteRowsNodes,
                        setUpdatedTableData: this.setUpdatedTableData,
                      }}
                      settings={{ concept: trigger.ancestor, show_pids: [] }}
                      preloadedData={{
                        ...data,
                      }}
                      updateFilter={trigger}
                    />
                  </div>
                : null}
              </div>
            :
              <div className={`${classes.p10} ${classes.ml10}`} style={{ background: '#fff', width: 'fit-content' }}>
                {macroNode ?
                  <Node
                    isLink
                    isRemovable
                    onRemoveClick={() => {
                      this.onChangeNodeClick(null);
                      this.setState({ macroNode: null });
                    }}
                    size="sm"
                    node={macroNode}
                    nodeId={macroNode.id}
                    nodes={nodesData}
                  />
                :
                  <Search
                    showConcepts
                    containerStyles={{
                      height: 24,
                    }}
                    onDropdownElementClick={(e) => {
                      this.onChangeNodeClick(e.node);
                      this.setState({
                        nodesData: {
                          //...nodesData,
                          ...e.nodesData,
                        },
                      })
                    }}
                  />
                }
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
};

export default connect((state) => (
  {
    setup: state.meta.setup,
    light_meta_and_ops: state.meta.light_meta_and_ops,
  }
))(withStyles(styles)(PlayGround));
